import { jsx as r } from "react/jsx-runtime";
import { c as v } from "react/compiler-runtime";
import { useTheme as q, Box as z, IconButton as E } from "@mui/material";
import M from "@mui/icons-material/KeyboardDoubleArrowLeft";
import R from "@mui/icons-material/KeyboardDoubleArrowRight";
import $ from "@mui/icons-material/KeyboardArrowLeft";
import j from "@mui/icons-material/KeyboardArrowRight";
import { styles as F } from "./styles.js";
const G = (C) => {
  const e = v(8), {
    onClick: y,
    disabled: l,
    ariaLabel: A,
    icon: a
  } = C, t = l ? "text.disabled" : "text.primary";
  let o;
  e[0] !== t ? (o = {
    ...F.paginationButton,
    color: t
  }, e[0] = t, e[1] = o) : o = e[1];
  let n;
  return e[2] !== A || e[3] !== l || e[4] !== a || e[5] !== y || e[6] !== o ? (n = /* @__PURE__ */ r(E, { onClick: y, disabled: l, "aria-label": A, sx: o, children: a }), e[2] = A, e[3] = l, e[4] = a, e[5] = y, e[6] = o, e[7] = n) : n = e[7], n;
};
function X(C) {
  const e = v(44), {
    count: y,
    page: l,
    rowsPerPage: A,
    onPageChange: a
  } = C, t = q(), o = Math.max(0, Math.ceil(y / A) - 1), n = l === 0, s = l >= o;
  let k;
  e[0] !== a ? (k = (T) => (_) => {
    a(_, T);
  }, e[0] = a, e[1] = k) : k = e[1];
  const i = k;
  let c;
  e[2] !== i ? (c = i(0), e[2] = i, e[3] = c) : c = e[3];
  let d;
  e[4] !== t.direction ? (d = t.direction === "rtl" ? /* @__PURE__ */ r(R, {}) : /* @__PURE__ */ r(M, {}), e[4] = t.direction, e[5] = d) : d = e[5];
  let f;
  e[6] !== n || e[7] !== c || e[8] !== d ? (f = {
    onClick: c,
    disabled: n,
    ariaLabel: "first page",
    icon: d
  }, e[6] = n, e[7] = c, e[8] = d, e[9] = f) : f = e[9];
  const I = l - 1;
  let m;
  e[10] !== i || e[11] !== I ? (m = i(I), e[10] = i, e[11] = I, e[12] = m) : m = e[12];
  let p;
  e[13] !== t.direction ? (p = t.direction === "rtl" ? /* @__PURE__ */ r(j, {}) : /* @__PURE__ */ r($, {}), e[13] = t.direction, e[14] = p) : p = e[14];
  let g;
  e[15] !== n || e[16] !== m || e[17] !== p ? (g = {
    onClick: m,
    disabled: n,
    ariaLabel: "previous page",
    icon: p
  }, e[15] = n, e[16] = m, e[17] = p, e[18] = g) : g = e[18];
  const K = l + 1;
  let b;
  e[19] !== i || e[20] !== K ? (b = i(K), e[19] = i, e[20] = K, e[21] = b) : b = e[21];
  let u;
  e[22] !== t.direction ? (u = t.direction === "rtl" ? /* @__PURE__ */ r($, {}) : /* @__PURE__ */ r(j, {}), e[22] = t.direction, e[23] = u) : u = e[23];
  let h;
  e[24] !== s || e[25] !== b || e[26] !== u ? (h = {
    onClick: b,
    disabled: s,
    ariaLabel: "next page",
    icon: u
  }, e[24] = s, e[25] = b, e[26] = u, e[27] = h) : h = e[27];
  let x;
  e[28] !== i || e[29] !== o ? (x = i(o), e[28] = i, e[29] = o, e[30] = x) : x = e[30];
  let P;
  e[31] !== t.direction ? (P = t.direction === "rtl" ? /* @__PURE__ */ r(M, {}) : /* @__PURE__ */ r(R, {}), e[31] = t.direction, e[32] = P) : P = e[32];
  let L;
  e[33] !== s || e[34] !== x || e[35] !== P ? (L = {
    onClick: x,
    disabled: s,
    ariaLabel: "last page",
    icon: P
  }, e[33] = s, e[34] = x, e[35] = P, e[36] = L) : L = e[36];
  let w;
  e[37] !== h || e[38] !== L || e[39] !== f || e[40] !== g ? (w = [f, g, h, L], e[37] = h, e[38] = L, e[39] = f, e[40] = g, e[41] = w) : w = e[41];
  const D = w;
  let B;
  return e[42] !== D ? (B = /* @__PURE__ */ r(z, { sx: F.paginationActions, children: D.map(H) }), e[42] = D, e[43] = B) : B = e[43], B;
}
function H(C, e) {
  return /* @__PURE__ */ r(G, { ...C }, e);
}
export {
  X as PaginationActions
};
